export default {"src":"/_next/static/media/error.b470a2cf.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};